<template>
    <el-dialog
        :visible.sync="visible"
        :title="$t('Finance.Bank.money')"
        left>
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            :status-icon="true"
            label-position="right"
            label-width="98px"
            label-suffix=":">
            <el-form-item prop="bank" :label="$t('Finance.Bank.open')">
                <el-select
                    style="width: 100%;"
                    v-model="form.bank"
                    :placeholder="$t('Finance.Bank.choose_open')">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="city" :label="$t('Finance.Bank.city')">
                <div class="flex">
                    <el-input v-model="form.city"></el-input>
                    <span>&nbsp;{{ $t('Finance.Bank.shi') }}&nbsp;</span>
                    <el-input v-model="form.area"></el-input>
                    <span>&nbsp;{{ $t('Finance.Bank.qu') }}</span>
                </div>
            </el-form-item>
            <el-form-item prop="bank_name" :label="$t('Finance.Bank.name')">
                <el-input
                    v-model="form.bank_name"
                    :placeholder="$t('Finance.Bank.name_as')">
                </el-input>
            </el-form-item>
            <el-form-item prop="bank_owner" :label="$t('Finance.Bank.client_name')">
                <el-input
                    v-model="form.bank_owner"
                    :placeholder="$t('Finance.Bank.client_as')">
                </el-input>
            </el-form-item>
            <el-form-item prop="bank_number" :label="$t('Finance.Bank.account')">
                <el-input
                    v-model="form.bank_number"
                    :placeholder="$t('Finance.Bank.fill_account')">
                </el-input>
            </el-form-item>
            <el-form-item prop="password" :label="$t('Staff.password')">
                <el-input
                    type="password"
                    v-model.trim="form.password"
                    :placeholder="$t('Common.fill_password')">
                </el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button
                @click="confirm"
                type="primary"
            >{{ $t('Common.submit') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui';

export default {
    components: {
        ElDialog: Dialog,
    },
    data() {
        return {
            visible: false,
            form: {
                city: '',
                bank: '0',
                area: '',
                bank_name: '',
                bank_owner: '',
                bank_number: '',
                password: '',
            },
            options: [
                {
                    value: '0',
                    label: '请选择',
                }, {
                    value: '1',
                    label: '中国工商银行',
                }, {
                    value: '2',
                    label: '中国农业银行',
                }, {
                    value: '3',
                    label: '建设银行',
                }, {
                    value: '4',
                    label: '交通银行',
                }, {
                    value: '5',
                    label: '招商银行',
                }, {
                    value: '6',
                    label: '中信银行',
                }, {
                    value: '7',
                    label: '中国银行',
                }, {
                    value: '8',
                    label: '兴业银行',
                }, {
                    value: '10',
                    label: '浦发银行',
                }, {
                    value: '11',
                    label: '华夏银行',
                }, {
                    value: '12',
                    label: '南京银行',
                }, {
                    value: '13',
                    label: '江苏银行',
                }, {
                    value: '14',
                    label: '上海银行',
                }, {
                    value: '15',
                    label: '宁波银行',
                }, {
                    value: '16',
                    label: '中国民生银行',
                }, {
                    value: '17',
                    label: '广东发展银行',
                }, {
                    value: '18',
                    label: '深圳发展银行',
                }, {
                    value: '19',
                    label: '中国光大银行',
                }, {
                    value: '20',
                    label: '中国邮政储蓄银行',
                }, {
                    value: '21',
                    label: '农村商业银行',
                }, {
                    value: '22',
                    label: '北京银行',
                }, {
                    value: '23',
                    label: '北京农商银行',
                }, {
                    value: '24',
                    label: '平安银行',
                },
            ],
            rules: {
                city: { type: 'string', required: true, message: this.$t('Fill.Bank.city') },
                area: { type: 'string', required: true, message: this.$t('Fill.Bank.qu') },
                bank: { required: true, message: this.$t('Fill.Bank.bank') },
                bank_name: { type: 'string', required: true, message: this.$t('Fill.Bank.name') },
                bank_owner: { type: 'string', required: true, message: this.$t('Fill.Bank.open') },
                bank_number: { type: 'string', required: true, message: this.$t('Fill.Bank.account') },
                password: { type: 'string', required: true, message: this.$t('Common.fill_password') },
            },
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    methods: {
        resetForm() {
            this.$refs.form.resetFields();
        },
        open() {
            this.visible = true;
        },
        confirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return false;
                this.visible = false;
            });
        },
    },
};
</script>

<style lang="scss">
.el-dialog {
    width: 540px;
    margin: 0 !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.el-dialog--center .el-dialog__body {
    padding: 25px 25px 0;
}
</style>
